import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BackendService {
  headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(private http: HttpClient) {}

  get(url: string): Observable<any> {
    return this.http.get(url, { headers: this.headers });
  }

  getWithType<T>(path: string, options = {}): Observable<T> {
    return this.http.get<T>(path, { headers: this.headers, ...options });
  }

  getWithParams(url: string, params): Observable<any> {
    return this.http.get(url, { ...params, headers: this.headers });
  }

  getWithOptions(url: string, options) {
    return this.http.get(url, options);
  }

  post(url: string, body): Observable<any> {
    return this.http.post(url, body);
  }

  postWithOptions(url: string, body, httpOptions): Observable<any> {
    return this.http.post(url, body, httpOptions);
  }

  update(url: string, params): Observable<any> {
    return this.http.put(url, params);
  }

  patch(url: string, params): Observable<any> {
    return this.http.patch(url, params);
  }

  delete(url: string): Observable<any> {
    return this.http.delete(url, { headers: this.headers });
  }
}
